import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('WARNING').plugin(axiosPlugin);

let fetchWarningAction = redux.fetchActionGetOne();
let updateUserWarningsAction = redux.fetchActionUpdate();


export const fetchWarning = (warningId, query = {}) => fetchWarningAction(`/warnings/${warningId}?${queryString.stringify(query)}`);
export const updateWarningStatus = ( warningId = null, data) => updateUserWarningsAction(`/warnings/${warningId}/update-status`, data);
export const updateWarningContent = ( warningId = null, data) => updateUserWarningsAction(`/warnings/${warningId}/update-content`, data);
export const resetWarning = () => redux.actions.reset();

export const warning = redux.reducer();